import { Injectable } from '@angular/core';

@Injectable()
export class StringModifierServiceProvider {
	selectedText = ' (selected)';

	constructor() {}

	private getSelectedPointOffset(string: string): number {
		const selectedPoint = this.selectedText;
		return string.length - selectedPoint.length;
	}

	private isSelectedText(string: string): boolean {
		const selectedPoint = this.selectedText;
		return string.endsWith(selectedPoint);
	}

	cutSelectedText = (string: string) => {
		let result = string;
		if (this.isSelectedText(string)) {
			const selectedPointOffset = this.getSelectedPointOffset(string);
			result = string.substring(0, selectedPointOffset);
		}

		return result;
	};

	addSelectedText = (string: string) => {
		if (this.isSelectedText(string)) {
			return string;
		}
		string += this.selectedText;
		return string;
	};

	getUsedWorkflowsString = (workflowNames): string => {
		const SEPARATOR = ', ';
		const STRING_START = ' (';
		const STRING_END = ')';

		const workflowsNumber = workflowNames.length;
		const isMultipleWorkflows = workflowsNumber > 1;

		const assignedTo = `${STRING_START}Assigned to workflow${
			isMultipleWorkflows ? 's:' : ':'
		}`;

		let workflowsList = '';

		workflowNames.forEach((workflowName, index) => {
			const isLastElement = index === workflowsNumber - 1;
			workflowsList += workflowName + (isLastElement ? STRING_END : SEPARATOR);
		});

		return `${assignedTo} ${workflowsList}`;
	};

	urlEncodDataTransform = (obj): string => {
		const str = [];
		for (const p in obj) {
			str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
		}
		return str.join('&');
	};

	convertAmountIntoNumber(value: any): number {
		if (isNaN(value)) {
			const initalValue = value.replace(/[$,]/g, '');
			return Number(initalValue);
		}
		return +value;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/services/helpers/string-modifier-service/stringModifier.service.ts